<template>
  <div class="contact-container">
    <!-- 联系我们部分 -->
    <section class="contact-section">
      <h1 class="section-title">联系我们</h1>
      <div class="contact-info">
        <div v-for="(item, index) in contactItems" :key="index" class="info-item">
          <i :class="item.icon"></i>
          <span>{{ item.text }}</span>
        </div>
      </div>
    </section>

    <!-- 需求留言部分 -->
    <section class="demand-section">
      <h1 class="section-title">需求留言</h1>
      <el-form
          ref="formRef"
          :model="form"
          :rules="rules"
          label-width="100px"
          class="demand-form"
          @submit.prevent="submitForm"
      >
        <div class="form-row">
          <el-form-item label="姓名" prop="name" class="form-item">
            <el-input
                v-model="form.name"
                placeholder="请输入您的姓名"
                clearable
            />
          </el-form-item>

          <el-form-item label="手机" prop="phone" class="form-item">
            <el-input
                v-model="form.phone"
                placeholder="请输入您的手机号码"
                clearable
            />
          </el-form-item>
        </div>

        <div class="form-row">
          <el-form-item label="邮箱" prop="email" class="form-item">
            <el-input
                v-model="form.email"
                placeholder="请输入您的邮箱地址"
                clearable
            />
          </el-form-item>

          <el-form-item label="公司" class="form-item">
            <el-input
                v-model="form.company"
                placeholder="请输入您的公司名称"
                clearable
            />
          </el-form-item>
        </div>

        <div class="form-row">
          <el-form-item label="详细地址" prop="address" class="form-item">
            <el-input
                v-model="form.address"
                placeholder="请输入您的详细地址"
                clearable
            />
          </el-form-item>

          <el-form-item label="业务类型" prop="businessId" class="form-item">
            <el-select
                v-model="form.businessId"
                placeholder="请选择业务类型"
                clearable
            >
              <el-option
                  v-for="option in solutions"
                  :key="option.id"
                  :label="option.name"
                  :value="option.id"
              />
            </el-select>
          </el-form-item>
        </div>

        <el-form-item label="需求留言" prop="text" class="full-width">
          <el-input
              type="textarea"
              v-model="form.text"
              :rows="4"
              placeholder="请输入您的需求或留言"
              resize="none"
          />
        </el-form-item>

        <el-form-item label="验证码" prop="captcha" class="form-item">
          <div class="captcha-container">
            <el-input
                v-model="form.captcha"
                placeholder="请输入验证码"
                style="width: 150px; margin-right: 10px;"
            />
            <div class="captcha-code" @click="refreshCaptcha">
              {{ captchaText }}
            </div>
          </div>
        </el-form-item>

        <el-form-item class="form-actions">
          <el-button @click="resetForm">清空</el-button>
          <el-button type="primary" native-type="submit">提交</el-button>
        </el-form-item>
      </el-form>
    </section>

    <!-- 提交成功弹窗 -->
    <el-dialog
        v-model="successDialogVisible"
        title="提交成功"
        width="30%"
        center
    >
      <span>我们已经收到您的留言，会尽快与您联系确认！</span>
      <template #footer>
        <span class="dialog-footer">
          <el-button type="primary" @click="successDialogVisible = false">确定</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { reactive, ref, onMounted } from 'vue'
import { ElMessage } from 'element-plus'
import serviceApi from '@/api/server'

export default {
  setup() {
    const validBooln= ref(false)
    const formRef = ref(null)
    const solutions = ref([])
    const successDialogVisible = ref(false)
    const captchaText = ref('')

    const form = reactive({
      id: null,
      name: '',
      phone: '',
      email: '',
      company: '',
      address: '',
      businessId: null,
      text: '',
      time: null,
      captcha: ''
    })

    const rules = {
      name: [
        { required: true, message: '请输入姓名', trigger: 'blur' },
        { min: 2, max: 10, message: '长度在2到10个字符', trigger: 'blur' }
      ],
      phone: [
        { required: true, message: '请输入手机号码', trigger: 'blur' },
        { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号码', trigger: 'blur' }
      ],
      email: [
        { type: 'email', message: '请输入正确的邮箱地址', trigger: 'blur' }
      ],
      address: [
        {  required: true, message: '请输入省市区，以及详细地址', trigger: 'blur' }
      ],
      businessId: [
        { required: true, message: '请选择业务类型', trigger: 'blur' }
      ],
      text: [
        { required: true, message: '请输入需求留言', trigger: 'blur' },
        { min: 10, message: '至少输入10个字符', trigger: 'blur' }
      ],
      captcha: [
        { required: true, message: '请输入验证码', trigger: 'blur' },
        {
          validator: (rule, value, callback) => {
            if (value !== captchaText.value) {
              callback(new Error('验证码不正确'))
            } else {
              callback()
            }
          },
          trigger: 'blur'
        }
      ]
    }

    const contactItems = [
      { icon: 'el-icon-location', text: '地址：四川省成都市锦江区绿地中心.468锦锋，门牌号3907号' },
      { icon: 'el-icon-time', text: '营业时间：周一至周五9：00-17：30 周六至周日法定节假日休息' },
      { icon: 'el-icon-phone', text: '联系电话：028-84790373' }
    ]

    const businessOptions = reactive([])

    // 生成随机验证码
    const generateCaptcha = () => {
      const chars = '0123456789'
      let result = ''
      for (let i = 0; i < 4; i++) {
        result += chars.charAt(Math.floor(Math.random() * chars.length))
      }
      captchaText.value = result
    }

    // 刷新验证码
    const refreshCaptcha = () => {
      generateCaptcha()
    }

    // 提交
    const submitForm = () => {
      formRef.value.validate()
          .then(valid => {
            if (valid) {
              if (form === null || form === "") {
                ElMessage.error('请填写完整信息');
                return;
              }
              serviceApi.setRequestMessage(form).then(res => {
                successDialogVisible.value = true;
                serviceApi.sendAdminTuiShong(res.data.data).then(res => {
                  formRef.value.resetFields();
                  refreshCaptcha();
                });
              }).catch(err => {
                ElMessage.error('提交失败！');
              });
            }
          })
          .catch(error => {
            ElMessage.error('请检查表单内容是否正确填写');
            console.error("表单验证失败：", error);
          });
    };


    const resetForm = () => {
      formRef.value.resetFields()
      refreshCaptcha()
    }

    // 初始化验证码
    onMounted(() => {
      generateCaptcha()
    })

    return {
      formRef,
      solutions,
      validBooln,
      form,
      rules,
      contactItems,
      businessOptions,
      submitForm,
      resetForm,
      captchaText,
      refreshCaptcha,
      successDialogVisible
    }
  },
  created() {
    serviceApi.getBusinessList().then(res =>{
      this.solutions=res.data.data
    })
  }
}
</script>

<style lang="scss" scoped>
.contact-container {
  max-width: 1000px;
  margin: 0 auto;
  margin-top: 150px;
  padding: 0 20px;
}

.contact-section,
.demand-section {
  margin-bottom: 40px;
  padding: 30px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.section-title {
  font-size: 24px;
  color: #333;
  margin-bottom: 25px;
  padding-bottom: 15px;
  border-bottom: 1px solid #eee;
  text-align: center;
}

.contact-info {
  padding: 0 20px;
}

.info-item {
  margin-bottom: 20px;
  display: flex;
  align-items: flex-start;

  i {
    margin-right: 10px;
    color: #409EFF;
    font-size: 18px;
    margin-top: 3px;
  }

  span {
    font-size: 16px;
    color: #666;
    line-height: 1.6;
  }
}

.demand-form {
  padding: 0 20px;

  .form-row {
    display: flex;
    gap: 20px;
    margin-bottom: 22px;

    .form-item {
      flex: 1;
      margin-bottom: 0;
    }
  }

  .full-width {
    width: 100%;
    margin-bottom: 22px;
  }
}

.captcha-container {
  display: flex;
  align-items: center;
}

.captcha-code {
  width: 100px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  background-color: #f5f5f5;
  border-radius: 4px;
  font-size: 20px;
  letter-spacing: 5px;
  cursor: pointer;
  user-select: none;
  color: #333;
  border: 1px solid #dcdfe6;
}

.form-actions {
  display: flex;
  justify-content: center;
  margin-top: 30px;

  .el-button {
    width: 120px;
    margin: 0 15px;
  }
}

@media (max-width: 768px) {
  .contact-container {
    margin-top: 100px;
    padding: 0 15px;
  }

  .contact-section,
  .demand-section {
    padding: 20px 15px;
  }

  .contact-info,
  .demand-form {
    padding: 0;
  }

  .demand-form .form-row {
    flex-direction: column;
    gap: 0;

    .form-item {
      margin-bottom: 22px;
    }
  }

  .form-actions .el-button {
    width: 100px;
    margin: 0 10px;
  }

  .captcha-container {
    flex-direction: column;
    align-items: flex-start;

    .el-input {
      margin-bottom: 10px;
      margin-right: 0;
      width: 100% !important;
    }

    .captcha-code {
      width: 100px;
    }
  }
}
</style>